module.exports = __webpack_public_path__ + "static/media/icon-notify-update.36b68511.svg";